import { ConnectAppDataState } from '../../../../@types';

const initialState: ConnectAppDataState = {
  cars: [],
  devices: [],
  fuelCards: [],
  installation: null,
};
export default initialState;
